import apiHelpers from './apiHelpers';
import {getBoardset, setBoardset} from './apiServices';

function updateBoardsetId(oldId, newId) {
    const boardset = getBoardset();
    boardset.splice(boardset.findIndex((id) => id === oldId), 1, newId);
    setBoardset(boardset);
}

function getBoardForSave(board) {
    const clearBoard = _.cloneDeep(board);
    delete clearBoard.id;
    delete clearBoard.uniqueId;
    delete clearBoard.allEvents;
    delete clearBoard.allEventsAndAllFormulas;
    delete clearBoard.allFormulas;
    delete clearBoard.styles;
    delete clearBoard.featuresFromResponse;
    delete clearBoard.tempData;
    delete clearBoard.predictions;
    delete clearBoard.savedData;
    delete clearBoard.loadedId;
    delete clearBoard.bundleIdFilters;
    clearBoard.deletedEvents = [];
    clearBoard.deletedFormulas = [];
    clearBoard.featuresData.forEach((featureData) => {
        delete featureData.rows;
        delete featureData.filterValue;
        delete featureData.itemsChanges;
        delete featureData.styles;
        delete featureData.filters;
    });
    clearBoard.features.forEach((featureData) => {
        delete featureData.filters;
    });
    clearBoard.isFirstTimeLoaded = false;
    return clearBoard;
}

export default {
    getBoardsObjectFromArray(boardsArray) {
        const boardObject = {};
        boardsArray.forEach((board) => {
            const boardWithoutId = _.cloneDeep(board);
            delete boardWithoutId.id;
            boardObject[board.id] = boardWithoutId;
        });
        return boardObject;
    },

    async getBoards() {
        return apiHelpers.httpRequest('meta', {}, 'get');
    },
    async getBoardById(boardId, isShared = false) {
        if (!isShared) {
            localStorage.removeItem('lastPage');
        }
        return apiHelpers.httpRequest(`meta?board_id=${boardId}`, {}, 'get');
    },
    addBoardToBoardset(boardId) {
        const boardsWithNewId = _.cloneDeep(getBoardset()).concat(boardId);
        setBoardset(boardsWithNewId);
        return apiHelpers.httpRequest('meta/boardset', boardsWithNewId, 'put');
    },
    clearBoardset() {
        return apiHelpers.httpRequest('meta/boardset', [], 'put');
    },
    swapBoardsInBoardset(oldIndex, newIndex) {
        const boards = getBoardset();
        const deleteIndex = newIndex > oldIndex ? oldIndex : oldIndex + 1;
        const setIndex = newIndex > oldIndex ? newIndex + 1 : newIndex;
        boards.splice(setIndex, 0, _.cloneDeep(boards[oldIndex]));
        boards.splice(deleteIndex, 1);
        setBoardset(boards);
        return apiHelpers.httpRequest('meta/boardset', boards, 'put');
    },
    createBoard(board, editMode) {
        const boardForSave = getBoardForSave(board);
        if (editMode) {
            return apiHelpers.httpRequest(`meta/boards?index=${getBoardset().length}`, boardForSave, 'post').then((resolve) => {
                setBoardset(getBoardset().concat(resolve.data.id));
                return apiHelpers.emptyPromise(resolve);
            });
        }
        return apiHelpers.httpRequest(`meta/boards?index=10000`, boardForSave, 'post');
    },
    createEmptyBoard(boardForSave) {
        return apiHelpers.httpRequest(`meta/boards`, boardForSave, 'post');
    },
    updateBoard(board, isEdit) {
        const boardIndex = getBoardset().findIndex((id) => id === board.id);
        const boardForSave = getBoardForSave(board);
        if (isEdit) {
            return apiHelpers.httpRequest(`meta/boards?index=${boardIndex}`, boardForSave, 'post').then((resolve) => {
                updateBoardsetId(board.id, resolve.data.id);
                return apiHelpers.emptyPromise(resolve);
            });
        }
        return this.createEmptyBoard(boardForSave);
    },
    deleteBoardById(boardId, isEdit) {
        if (isEdit) {
            const boardsWithoutDeleted = getBoardset().filter((id) => id !== boardId);
            setBoardset(boardsWithoutDeleted);
            return apiHelpers.httpRequest('meta/boardset', boardsWithoutDeleted, 'put');
        }
        return apiHelpers.emptyPromise();
    },
    importBoardById(boardId) {
        const addBoardToBoardset = this.addBoardToBoardset(boardId);
        const getBoard = this.getBoardById(boardId, true);
        return Promise.all([addBoardToBoardset, getBoard]);
    },
};
